import { create } from 'zustand';
import { BaseAppState, PanelEnum } from '@shared/app/types';

/** Factory function to create a separate Zustand store per app */
export const createAppStore = (appId: string) =>
  create<BaseAppState>((set, get) => ({
    appId, // Store app-specific ID for debugging/logging
    mountedViews: {
      panelA: [],
      panelB: [],
      floating: [],
      settings: [],
    },

    mountView: (panel: PanelEnum, viewName: string) => {
      const id = `${panel}-${viewName}-${Date.now()}`;
      set((state) => ({
        mountedViews: {
          ...state.mountedViews,
          [panel]: [...(state.mountedViews[panel] || []), { id, name: viewName, panel }],
        },
      }));
    },

    unmountView: (panel: PanelEnum, viewId) => {
      set((state) => ({
        mountedViews: {
          ...state.mountedViews,
          [panel]: (state.mountedViews[panel] || []).filter((view) => view.id !== viewId),
        },
      }));
    },

    getViewsForPanel: (panel: PanelEnum) => get().mountedViews[panel] || [],

    isAppReady: false,
    setAppReady: () => set({ isAppReady: true }),
  }));
